import AuthStore from "store/auth";
import ItemStore from "store/item";

const Store = {
  auth: AuthStore,
  item: ItemStore,
};

export default Store;
